module.exports = __webpack_public_path__ + "static/media/JINGLE_END.f09f4411.mp3";